/* Outlecta pages (2026-10-16): mjuk FAQ-accordion, kontaktformulär och innehållsförteckning. Inga beroenden. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.22, 1, .36, 1)';

  /* ---------- FAQ: animerad höjd, en öppen i taget ---------- */
  function openItem(d) {
    var c = d.querySelector('.accordion__content');
    var start = d.offsetHeight;
    if (d._anim) { d._anim.cancel(); d._anim = null; }
    d.style.overflow = 'hidden';
    d.open = true;
    var end = d.offsetHeight;
    d._closing = false;
    d._anim = d.animate({ height: [start + 'px', end + 'px'] }, { duration: 560, easing: EASE });
    d._anim.onfinish = function () { d.style.overflow = ''; d._anim = null; };
    if (c) c.animate([{ opacity: 0, transform: 'translateY(-8px)' }, { opacity: 1, transform: 'none' }], { duration: 520, delay: 90, easing: EASE, fill: 'backwards' });
  }
  function closeItem(d) {
    var s = d.querySelector('summary');
    var start = d.offsetHeight;
    if (d._anim) { d._anim.cancel(); d._anim = null; }
    d.style.overflow = 'hidden';
    d._closing = true;
    d._anim = d.animate({ height: [start + 'px', s.offsetHeight + 'px'] }, { duration: 420, easing: EASE });
    d._anim.onfinish = function () { d.open = false; d._closing = false; d.style.overflow = ''; d._anim = null; };
  }
  function closeOthers(d) {
    var root = d.closest('.collapsible-content') || document;
    root.querySelectorAll('.accordion details[open]').forEach(function (o) {
      if (o === d || o._closing) return;
      if (reduce) o.open = false; else closeItem(o);
    });
  }
  function bindItem(d) {
    if (d.dataset.oxBound) return;
    d.dataset.oxBound = '1';
    var s = d.querySelector('summary');
    if (!s) return;
    s.addEventListener('click', function (e) {
      if (reduce || !d.animate) { if (!d.open) closeOthers(d); return; }
      e.preventDefault();
      if (d.open && !d._closing) { closeItem(d); }
      else { closeOthers(d); openItem(d); }
    });
  }
  function initFaq(scope) {
    (scope || document).querySelectorAll('.collapsible-content .accordion details').forEach(bindItem);
  }

  /* ---------- Gemensam mjuk scroll till ett mål (Lenis om den finns) ---------- */
  function scrollToEl(target, offset, done) {
    if (window.lenis && window.lenis.scrollTo) window.lenis.scrollTo(target, { offset: offset, onComplete: done });
    else { target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); if (done) setTimeout(done, reduce ? 0 : 500); }
  }

  /* ---------- Kontakt: snabbval fyller i ämnet, formuläret skickas en gång ---------- */
  function initContact(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-ox-topic]').forEach(function (a) {
      if (a.dataset.oxBound) return;
      a.dataset.oxBound = '1';
      a.addEventListener('click', function (e) {
        var target = document.getElementById('ox-form');
        if (!target) return;
        e.preventDefault();
        var radio = document.querySelector('input[data-topic="' + a.getAttribute('data-ox-topic') + '"]');
        if (radio) radio.checked = true;
        scrollToEl(target, -96, function () {
          var first = target.querySelector('input[type="text"], input[type="email"]');
          if (first) first.focus({ preventScroll: true });
        });
      });
    });
    scope.querySelectorAll('form.ox-form').forEach(function (f) {
      if (f.dataset.oxBound) return;
      f.dataset.oxBound = '1';
      f.addEventListener('submit', function () {
        var b = f.querySelector('button[type="submit"]');
        if (!b || !f.checkValidity()) return;
        var label = b.querySelector('[data-ox-label]');
        if (label && b.dataset.sending) label.textContent = b.dataset.sending;
        setTimeout(function () { b.disabled = true; }, 0);
      });
    });
  }

  /* ---------- Allmänna sidor: innehållsförteckning byggd av rubrikerna ---------- */
  function initToc(scope) {
    (scope || document).querySelectorAll('[data-ox-page]').forEach(function (sec) {
      if (sec.dataset.oxToc) return;
      sec.dataset.oxToc = '1';
      var toc = sec.querySelector('[data-ox-toc]');
      var prose = sec.querySelector('.ox-prose');
      var body = sec.querySelector('.ox-page__body');
      if (!toc || !prose || !body) return;
      var hs = [].slice.call(prose.querySelectorAll('h2, h3')).filter(function (h) { return h.textContent.trim(); });
      if (sec.getAttribute('data-toc') === 'false' || hs.length < 3) { toc.remove(); return; }
      var label = document.createElement('p');
      label.className = 'ox-toc__label';
      label.textContent = toc.getAttribute('data-label') || '';
      var ol = document.createElement('ol');
      var links = [];
      hs.forEach(function (h, i) {
        if (!h.id) h.id = 'ox-sec-' + (i + 1);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        a.addEventListener('click', function (e) {
          e.preventDefault();
          scrollToEl(h, -96);
        });
        li.appendChild(a); ol.appendChild(li); links.push(a);
      });
      toc.appendChild(label); toc.appendChild(ol);
      body.classList.add('has-toc');
      if (!('IntersectionObserver' in window)) return;
      var current = null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var idx = hs.indexOf(en.target);
          if (idx < 0) return;
          if (current) current.removeAttribute('aria-current');
          current = links[idx];
          current.setAttribute('aria-current', 'true');
        });
      }, { rootMargin: '-15% 0px -75% 0px' });
      hs.forEach(function (h) { io.observe(h); });
    });
  }

  function init(scope) { initFaq(scope); initContact(scope); initToc(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
